import React, { useState, useCallback } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { URL_AWS } from '../../constans/servidor';

import './verificarGopass.css';

const API_GOPASS = `${URL_AWS}/gopass/rest/main/getPlacasGopass`;
const CODPARK = '50';

const VerificarGopassPage = () => {
  const [placa, setPlaca] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const verificar = useCallback(async () => {
    const placaTrim = placa.trim().toUpperCase();
    if (!placaTrim) return;

    setLoading(true);
    setResult(null);

    try {
      const response = await fetch(`${API_GOPASS}/${placaTrim}/${CODPARK}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();

      if (data.status === true && data.data && data.data.length > 0) {
        const item = data.data[0];
        setResult({
          type: 'success',
          mensaje: data.mensaje,
          placa: item.placa,
          tid: item.tid,
          status: item.status === '1' ? 'Activo' : 'Inactivo',
          dateMod: item.dateMod,
        });
      } else {
        setResult({
          type: 'not-found',
          mensaje: data.mensaje || 'La placa no está registrada en Gopass.',
        });
      }
    } catch (err) {
      console.error(err);
      setResult({
        type: 'error',
        mensaje: 'No se pudo consultar el servicio. Verifica tu conexión e intenta de nuevo.',
      });
    } finally {
      setLoading(false);
    }
  }, [placa]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') verificar();
  };

  return (
    <>
      <div className="verificar-gopass-wrap">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} sm={12} md={8} lg={6}>
              <div className="verificar-gopass-card">
                <h1 className="verificar-gopass-title">Verificar Gopass</h1>
                <p className="verificar-gopass-subtitle">
                  Ingresa la placa del vehículo para comprobar si está registrada en Gopass.
                </p>

                <div className="verificar-gopass-fields-row">
                  <div className="verificar-gopass-field-group">
                    <label htmlFor="placa">Placa</label>
                    <input
                      type="text"
                      id="placa"
                      placeholder="Ej: KMT590"
                      maxLength={10}
                      value={placa}
                      onChange={(e) => setPlaca(e.target.value)}
                      onKeyDown={handleKeyDown}
                      className="verificar-gopass-input"
                    />
                  </div>
                  <div className="verificar-gopass-field-group">
                    <label htmlFor="codpark">Cód. Parqueadero</label>
                    <input
                      type="text"
                      id="codpark"
                      value={CODPARK}
                      readOnly
                      className="verificar-gopass-input verificar-gopass-input-readonly"
                    />
                  </div>
                </div>

                <button
                  type="button"
                  className="verificar-gopass-btn"
                  onClick={verificar}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="verificar-gopass-spinner" />
                      Verificando...
                    </>
                  ) : (
                    'Verificar'
                  )}
                </button>

                {result && (
                  <div className="verificar-gopass-result">
                    {result.type === 'success' && (
                      <div className="verificar-gopass-result-box success">
                        <div className="verificar-gopass-status-label">✔ Es Gopass</div>
                        <div className="verificar-gopass-mensaje">{result.mensaje}</div>
                        <div className="verificar-gopass-detail-grid">
                          <span className="key">Placa</span>
                          <span>{result.placa}</span>
                          {result.tid && (
                            <>
                              <span className="key">TID</span>
                              <span>{result.tid}</span>
                            </>
                          )}
                          <span className="key">Estado</span>
                          <span>{result.status}</span>
                          <span className="key">Última modificación</span>
                          <span>{result.dateMod}</span>
                        </div>
                      </div>
                    )}
                    {result.type === 'not-found' && (
                      <div className="verificar-gopass-result-box not-found">
                        <div className="verificar-gopass-status-label">⚠ No es Gopass</div>
                        <div className="verificar-gopass-mensaje">{result.mensaje}</div>
                      </div>
                    )}
                    {result.type === 'error' && (
                      <div className="verificar-gopass-result-box error">
                        <div className="verificar-gopass-status-label">✖ Error</div>
                        <div className="verificar-gopass-mensaje">{result.mensaje}</div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default VerificarGopassPage;
